<template>
    <span class="text-16 font-bold text-a-brown-9f8273">
        {{msg}}&nbsp;
    </span>
</template>
<script>
import LocaleMixin from '@/mixin/LocaleMixin';

export default {
    mixins: [LocaleMixin],
    data: function () {
        return {
            msg: 'Good morning,',
        };
    },
    created: function () {
        this.setMsg();
    },
    methods: {
        setMsg: function () {
            let date = new Date();
            let h = date.getHours();

            if (h >= 0 && h <= 11) {
                this.msg = this.lbl.main.greeting1;
            } else if (h == 12) {
                this.msg = this.lbl.main.greeting2;
            } else if (h >= 13 && h <= 17) {
                this.msg = this.lbl.main.greeting3;
            } else if (h >= 18) {
                this.msg = this.lbl.main.greeting4;
            }
        },
    },
}
</script>
<style lang="scss" scoped>
</style>
